export const SMART_GROUP_FILTER_TYPES = [
	{ filterType: 'locations', placeholder: 'Location' },
	{ filterType: 'ages', placeholder: 'Age' },
	{ filterType: 'gender', placeholder: 'Gender' },
	// recent: { filterType: 'recent', placeholder: 'Recent' },
	{ filterType: 'volunteers', placeholder: 'Create your own' },
];
